import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nouvelles',
  templateUrl: './nouvelles.component.html',
  styleUrls: ['./nouvelles.component.css']
})
export class NouvellesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
